/**
 * Stripe.js initialization
 *
 * Loads the Stripe publishable key from the VITE_STRIPE_PUBLISHABLE_KEY
 * environment variable and creates a singleton Stripe promise for use
 * with the <Elements> provider.
 *
 * Requirements: 8.5
 */

import { loadStripe } from '@stripe/stripe-js';

const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string;

export const stripePromise = stripePublishableKey
    ? loadStripe(stripePublishableKey)
    : null;
